module.exports = ".redColor{ color: red }"